import { render, staticRenderFns } from "./labelPrintSetting.vue?vue&type=template&id=63cb3fba&scoped=true&"
import script from "./labelPrintSetting.vue?vue&type=script&lang=js&"
export * from "./labelPrintSetting.vue?vue&type=script&lang=js&"
import style0 from "./labelPrintSetting.vue?vue&type=style&index=0&id=63cb3fba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cb3fba",
  null
  
)

export default component.exports